import React from "react";

import { Button, Stack } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { useAppDispatch } from "Hooks/useRedux";

import { changeMenu } from "Redux/menuSlice";

interface IProps {
  children: React.ReactNode;
}

export default function ListsHeader({ children }: IProps) {
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ mb: 5 }}>
      {children}

      <Button variant="contained" color="error" size="large" sx={{ p: 0 }} onClick={() => dispatch(changeMenu("disable"))}>
        <CloseOutlinedIcon />
      </Button>
    </Stack>
  );
}
